import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Col,
  Container,
  Row } from 'reactstrap';

class PersonifySignaturePending extends Component {
  render() {
    return (
      <div className="page-personify narrow">
        <Container>
          <Row>
            <Col md={8} className="text-center mb-2 mt-2 mt-md-5 ml-auto mr-auto">
              <img src="/images/personify-alert.svg" alt="Pending" className="mb-3" />
              <h2 className="mb-2">Agreement Signature Pending</h2>
              <p className="mb-4">Sorry, we were unable to confirm your identity. Call (800) 944-6177 to continue signing the loan agreement.</p>
              <Button tag={Link} to="/personify/sign" color="personify" size="lg" className="mb-2 mt-1">Continue Signing Loan Agreement</Button>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default PersonifySignaturePending;
